﻿// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import CourseItem from './components/CourseItem.vue';
import CourseSkeleton from './components/CourseSkeleton.vue';

const courseApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        CourseItem,
        CourseSkeleton
    }
};

export default courseApp;
